"use client";

import { forwardRef, useImperativeHandle, useState } from "react";

import { cn } from "@/shared/helpers/cn.helper";

import { MapPanelContext, type SelectedData } from "./map-panel-context";

import type { MapPanelProps, MapPanelTabKey } from "./map-panel.types";

export interface MapPanelRootRef {
  setOpen: (open: boolean) => void;
  toggle: () => void;
}

export const MapPanelRoot = forwardRef<MapPanelRootRef, React.PropsWithChildren<MapPanelProps>>(
  (
    {
      tabs,
      side = "left",
      defaultTabKey,
      defaultOpen = false,
      className,
      children,
    },
    ref,
  ) => {
    const [activeKey, setActiveKey] = useState<MapPanelTabKey>(
      defaultTabKey ?? tabs[0]?.key ?? "",
    );
    const [open, setOpen] = useState(defaultOpen);
    const [selectedData, setSelectedData] = useState<SelectedData>(null);

    const toggle = () => {
      setOpen((prev) => !prev);
    };

    useImperativeHandle(ref, () => ({
      setOpen,
      toggle,
    }));

    const value = {
      tabs,
      side,
      activeKey,
      setActiveKey,
      open,
      setOpen,
      selectedData,
      setSelectedData,
    };

    return (
      <MapPanelContext.Provider value={value}>
        <div
          className={cn(
            "pointer-events-none absolute inset-0 z-30 flex",
            className,
          )}
        >
          {children}
        </div>
      </MapPanelContext.Provider>
    );
  },
);

MapPanelRoot.displayName = "MapPanelRoot";

